'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBonusType = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Translate = require('../../components/Translate');

var _Translate2 = _interopRequireDefault(_Translate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBonusType = exports.getBonusType = function getBonusType(type) {
  var translations = {
    Monetary: _react2.default.createElement(_Translate2.default, { id: 'label.type.bonus.monetary', defaultMessage: 'Monetary' }),
    Freespins: _react2.default.createElement(_Translate2.default, { id: 'label.type.bonus.freespins', defaultMessage: 'Freespins' }),
    FreespinsMonetary: _react2.default.createElement(_Translate2.default, {
      id: 'label.type.bonus.freespinsMonetary',
      defaultMessage: 'Freespins Monetary'
    }),
    FreeBetsMonetary: _react2.default.createElement(_Translate2.default, {
      id: 'label.type.bonus.freeBetsMonetary',
      defaultMessage: 'Free Bets Monetary'
    }),
    Deposit: _react2.default.createElement(_Translate2.default, { id: 'label.type.bonus.deposit', defaultMessage: 'Deposit' })
  };

  return translations[type] || _react2.default.createElement(
    'span',
    null,
    type
  );
};